import { createContext, useContext } from "react";
import { UseUrlModalResult } from "@rapid/hooks/useUrlModal";

export type UrlModalContextValue = UseUrlModalResult;

export const UrlModalContext = createContext<UrlModalContextValue | null>(null);

export function useUrlModalContext(): UrlModalContextValue {
    const context = useContext(UrlModalContext);
    if (!context) {
        throw new Error("useUrlModalContext must be used within a UrlModalProvider");
    }
    return context;
}
